import React from 'react';

import { IconTypes } from '@eika/icon';
import { IconLink } from '@eika/link';

import { WispSignal } from '../../components/WispSignal';
import { useConfig } from '../../defaultConfig';
import DesktopHeaderIkon from './DesktopHeaderIkon';

import './CorporateHeaderApp.scss';

const CorporateHeaderApp: React.FC = () => {
    const { profileLink, frontpage, isNative } = useConfig();

    if (isNative) {
        if (frontpage) {
            return (
                <>
                    <div className="corporate-header__wisp-signal">
                        <WispSignal />
                    </div>
                    <IconLink
                        className="corporate-header__profile-button"
                        icon={IconTypes.BEDRIFT_24}
                        href={profileLink?.url}
                    />
                </>
            );
        }
        return null;
    }

    return <DesktopHeaderIkon />;
};

export default CorporateHeaderApp;
